<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link></li>
            <li><span class="divider"> / </span><a href="#">استعلام</a></li>
        </template>
    </Path>

    <section>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 final_step text-center">
                        <h2 class="blueFont">استعلام عن الطلب</h2>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-12 col-md-4 text-center">
                        <p class="fw-bold">رقم الطلب</p>
                        <input v-model="RequestId" type="text" class="form-control text-center" placeholder="" />
                    </div>
                </div>

                <div class="row my-4 justify-content-center">
                    <div class="col-12 col-sm-4 mb-3">
                        <div class="d-flex justify-content-center">
                            <button :disabled="!isInquiryAllowed || loading" @click="inquireRequest" type="button"
                                class="btn btn-light mx-3 align-self-center">
                                <span v-if="loading">جارٍ التحميل...</span>
                                <span v-else>استعلام</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <router-view></router-view>
</template>

<script>
import Path from "@/components/Path.vue";
import { debugLog } from "@/plugins/debug";

export default {
    name: "InquiryComp",
    components: { Path },
    data() {
        return {
            RequestId: "",
            isInquiryAllowed: true,
            loading: false,
        };
    },
    watch: {
        RequestId(newValue) {
            const id_regex = /^([0-9]{1,10})$/;
            if (!id_regex.test(newValue)) {
                this.isInquiryAllowed = false;
            } else {
                this.isInquiryAllowed = true;
            }
        },
    },
    methods: {
        async inquireRequest() {

            if (!this.RequestId) {
                this.$alerts.toast.error("برجاء إدخال رقم الطلب.");
                return;
            }

            this.loading = true;

            try {

                const res = await this.$api.requests.RequestStatus(
                    this.RequestId.toString()
                );

                if (res && res.data) {

                    debugLog("✅ Inquiry API Response:", res.data);

                    this.$router.push({
                        name: "inquiryResult",
                        params: { req_id: this.RequestId },
                        state: { responseData: res.data },
                    });
                }

            } catch (error) {

                if (error?.response?.status === 400) {

                    this.$alerts.toast.error(
                        error.response.data.ResponseMessage ||
                        "حدث خطأ أثناء الاستعلام"
                    );

                }

                console.error(error);

            } finally {

                // 🔥 Always re-enable inquiry button
                this.loading = false;

            }
        }
    },
};
</script>